import { Button, Card, Grid } from '@material-ui/core';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Redirect } from "react-router-dom";
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { ModificarAfiliadoRecupero } from './ModificarAfiliadoRecupero';
import AccionesGenericoAbm from '../../compartidos/abms/AccionesGenericoAbm';
import { AUTORIZACIONES_AFILIADO_RECUPERO } from '../../../utils/permisos';
import { EliminarAfiliadoRecupero } from '../../../actions/autorizaciones/Autorizaciones';

export const ListaAfiliadosRecupero = (props) => {

    const dispatch = useDispatch();
    const { afiliadosRecupero } = useSelector((state) => state.autorizaciones);
    const [openModalCambio, setOpenModalCambio] = useState(false);
    const [infoAfiliado, setInfoAfiliado] = useState("");
    const [redirect, setRedirect] = useState(false);


    const reinicio = () => {
        setRedirect(true)
    }

    const handleSelect = (item) => {
        setInfoAfiliado(item);
        setOpenModalCambio(true);

    }

    const handleDelete = (item) => {
        debugger
        const data = {
            idRecupero: item?.idRecupero
        }
        dispatch(EliminarAfiliadoRecupero(data, item?.idAfiliado))
    }



    console.log(afiliadosRecupero)

    return (
        <React.Fragment>
            {redirect && (
                <Redirect
                    to={{
                        pathname: '/autorizaciones/afiliadosRecupero',
                        state: {
                            from: '/autorizaciones/afiliadosRecupero',
                        },
                    }}
                />
            )}
            {openModalCambio && (
                <ModificarAfiliadoRecupero
                    open={openModalCambio}
                    closeModalHandler={() => {
                        setOpenModalCambio(false);
                    }}
                    infoAfiliado={infoAfiliado}

                />
            )}
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} md={8} style={{ paddingLeft: 0, marginTop: 20 }}>
                    <Card>
                        <TableGeneric
                            data={afiliadosRecupero}
                            sizeTableCells={["15%", "25%", "25%", "15%", "15%", "10%", "10%"]}
                            columns={[
                                {
                                    label: "",
                                    customBody: (item) => (
                                        <AccionesGenericoAbm
                                            item={item}
                                            handleItemSelect={handleSelect}
                                            permisoDelete={AUTORIZACIONES_AFILIADO_RECUPERO.ALTA}
                                            handleDelete={handleDelete}
                                        />
                                    )
                                },
                                {
                                    label: "Id Recupero",
                                    id: "idRecupero",
                                    sort: true
                                },
                                {
                                    label: "Carnet",
                                    id: "carnet",
                                    sort: true
                                },
                                {
                                    label: "Apellido y Nombre",
                                    id: "apellidoNombre",
                                    sort: true
                                },
                                {
                                    label: "Motivo Internacion",
                                    id: "descripcionMotivoInternacion",
                                    sort: true
                                },
                                {
                                    label: "Usuario Carga",
                                    id: "descripcionUsuarioCarga",
                                    sort: true
                                },
                                {
                                    label: "Fecha Accidente",
                                    id: "fechaIngreso",
                                    customBody: (item) =>
                                        moment(item.fechaIngreso).format("DD/MM/YYYY"),
                                },
                                {
                                    label: "Fecha Egreso",
                                    id: "fechaEgreso",
                                    customBody: (item) => {
                                        const fechaEgreso = item.fechaEgreso;
                                        return fechaEgreso ? moment(fechaEgreso).format("DD/MM/YYYY") : "Sin Egreso";
                                    },
                                },
                                {
                                    label: "Usuario Carga",
                                    id: "descripcionUsuarioCarga",
                                    sort: true
                                },
                                {
                                    label: "Fecha Baja",
                                    id: "fechaBaja",
                                    customBody: (item) => {
                                        const fechaBaja = item.fechaBaja;
                                        return fechaBaja ? moment(fechaBaja).format("DD/MM/YYYY") : "";
                                    },
                                },
                                {
                                    label: "Usuario Baja",
                                    id: "descripcionUsuarioBaja",
                                    sort: true
                                },

                            ]}
                        />
                    </Card>
                </Grid>
                <Grid item xs={12} md={8} style={{ paddingLeft: 0, marginTop: 20 }}>
                    <div
                        style={{
                            margin: '1rem 0',
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex',
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={reinicio}>
                            Reiniciar buscador
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
